import React from 'react'
import moment from 'moment'

// default styles
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
// custom styles
import './datepicker-styles.css'

import { DateRange } from 'react-date-range'

import { colors } from '../../../../styles'

function formatDate(d) {
  let month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear()

  if (month.length < 2)
      month = '0' + month
  if (day.length < 2)
      day = '0' + day

  return [year, month, day].join('-')
}


function Calendar({
  dateRange,
  onDatePick,
  disabledDates = [],
  disabledDay,
}) {
  const minDate = moment().add(1, 'day').toDate()
  const maxDate = moment().add(3, 'year').toDate()

  // No dates picked yet: react-date-range marks every day as in range when both
  // ends are null. An invalid end date shows an empty calendar instead.
  // (`dateRange?`: styled-components calls Calendar with no props, as ${Calendar} in SelectDatesModal.)
  const range = dateRange?.startDate ? dateRange : { startDate: null, endDate: new Date('') }

  return (
    <DateRange
      dateDisplayFormat="M / d / yyyy"
      startDatePlaceholder="Start date"
      endDatePlaceholder="End date"
      ranges={[{
        ...range,
        key: 'selection',
        color: colors.primaryBackground,
      }]}
      onChange={onDatePick}
      minDate={minDate}
      maxDate={maxDate}
      disabledDates={disabledDates}
      disabledDay={disabledDay}
    />
  )
}

export default Calendar
